export const api_key = "api_key=681677419193a087d2ddf6904b4dd759"; 
export const base_url = "https://api.themoviedb.org/3"
export const api_url = base_url + "/discover/movie?sort_by=popularity.desc&"+api_key;
// export const url = 'http://localhost/hosmdb'
export const url = 'https://hosmdb.herokuapp.com'